module.exports = __webpack_public_path__ + "static/media/universal-access.ad9eec43.svg";